// extracted by mini-css-extract-plugin
export default {"wrapper":"GameSeries_wrapper__GeChX","content":"GameSeries_content__xutGo"};